module.exports = __webpack_public_path__ + "static/media/main-visual-02-m.065d712.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-02-m.mp4
// module id = gCk/
// module chunks = 1